import {BaseUser, Condition, ImageValue} from '@legit.health/ui';
import SendIcon from '@mui/icons-material/Send';
import {Button} from '@mui/material';
import {TFunction} from 'i18next';
import {UseFormReturn} from 'react-hook-form';
import BottomBar from '@/shared/components/diagnosticReport/DiagnosticReportForm/steps/BottomBar';
import {ConditionInfo} from '@/shared/components/diagnosticReport/DiagnosticReportForm/types';
import {FormValues} from '../../types';
import RecordVideo from './components/RecordVideo';
import UploadImage from './components/UploadImage';

export default function UploadMedia({
  activeStep,
  isPending,
  condition,
  conditionInfo,
  form,
  onBack,
  onChangeImage,
  onChangeVideo,
  onNext,
  patient,
  t,
  totalSteps,
  withTemporaryImages
}: {
  activeStep: number;
  isPending: boolean;
  condition: Condition;
  conditionInfo: ConditionInfo | null;
  form: UseFormReturn<FormValues>;
  onBack: () => void;
  onChangeImage: (value: ImageValue) => void;
  onChangeVideo: (video: Blob | null) => void;
  onNext: () => void;
  patient: BaseUser;
  t: TFunction;
  totalSteps: number;
  withTemporaryImages: boolean;
}) {
  const image = form.watch('image');
  const video = form.watch('video');
  const hasScoringSystems = conditionInfo && conditionInfo.scoringSystemsIds.length > 0;
  return (
    <>
      {condition?.pathology.requiresVideo ? (
        <RecordVideo onChange={onChangeVideo} t={t} condition={condition} />
      ) : (
        <UploadImage
          onChange={onChangeImage}
          t={t}
          value={image}
          patient={patient}
          withTemporaryImages={withTemporaryImages}
        />
      )}
      <BottomBar
        activeStep={activeStep}
        isBackEnabled
        isNextEnabled={Boolean(image.file || video)}
        onBack={onBack}
        t={t}
        totalSteps={totalSteps}
        rightButton={
          <Button
            color="secondary"
            onClick={hasScoringSystems ? onNext : undefined}
            disableElevation
            disabled={Boolean(!image.file && !video) || isPending}
            size="medium"
            variant="contained"
            endIcon={<SendIcon />}
            type={hasScoringSystems ? 'button' : 'submit'}
            data-testid="stepperNextButton"
          >
            {isPending ? t('ui:sending') : hasScoringSystems ? t('ui:next') : t('ui:send')}
          </Button>
        }
      />
    </>
  );
}
